import React, { createElement, useMemo } from 'react';
import IconNames from '../../assets/icons/IconNames';
import iconSet from '../../assets/icons/config.json';
import { StyledSvg } from './styles';

export interface IconProps extends React.HTMLAttributes<any> {
  name: IconNames;
  size?: number;
}

export interface IPathAttr {
  fill?: string;
}

const Icon: React.FC<IconProps> = ({ name, size = 32, ...props }) => {
  const currentIcon = useMemo(
    () => iconSet[name as keyof typeof iconSet]?.icon,
    [name],
  );

  if (!currentIcon) return null;

  const { width = '1024' } = currentIcon;

  const viewBox = `0 0 ${width} 1024`;

  const children = currentIcon.paths.map((path: string, index: number) => {
    const attrs = currentIcon.attrs?.[index] as IPathAttr;

    const isColorful = name.includes('colorful');

    const returnFillIcon = () => {
      if (isColorful) return attrs?.fill;

      return props.color ?? attrs?.fill ?? 'currentColor';
    };

    const fillIcon = returnFillIcon();

    const pathProps = {
      d: path,
      key: path + index,
      ...attrs,
      fill: fillIcon,
    };

    return createElement('path', pathProps);
  });

  return (
    <StyledSvg size={size} viewBox={viewBox} fill="none" {...props}>
      {children}
    </StyledSvg>
  );
};

export default Icon;
